let domain = {
  development: {
    host: 'localhost'
  },
  test: {
    host: 'szizai-test.cbreip.com'
  },
  devTest: {
    host: '192.168.197.27'
  },
  production: {
    host: 'szizai.cbreip.com'
  }
};
let hostName = location.hostname;
let _env;
let _homeUrl;

if (hostName === domain.development.host) {
  _env = 'development';
  _homeUrl = 'http://192.168.197.27:7666/cbreplatform/login.xhtml';
} else if (hostName === domain.test.host) {
  _env = 'test';
  _homeUrl = 'https://portal.test.cbreip.com/cbreplatform/index.xhtml';
} else if (hostName === domain.test.devTest) {
  _env = 'devTest';
  _homeUrl = 'http://192.168.197.27:7666/cbreplatform/login.xhtml';
} else {
  _env = 'production';
  _homeUrl = 'https://portal.cbreip.com/cbreplatform/login.xhtml';
}

export const env = _env;
export const homeUrl = _homeUrl;



// WEBPACK FOOTER //
// ./src/utils/config.js